export const getCaseUrl = ({ caseId }: { caseId: string }) => `cases/${caseId}`;
